module.exports = __webpack_public_path__ + "img/domain-04.41435f89.png";